<script>
export default {
  name: "ScanLogsPanel",
  props: {
    logs: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<template>
  <div class="comp-box">
    <h6 class="section-title q-mt-none q-mb-sm">최근 스캔 로그 (최대 10건)</h6>
    <q-markup-table flat bordered dense>
      <thead>
        <tr>
          <th class="text-left">시각</th>
          <th class="text-left">유형</th>
          <th class="text-left">입력값</th>
          <th class="text-left">결과</th>
          <th class="text-left">상세</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in logs" :key="log.id">
          <td>{{ log.at }}</td>
          <td>{{ log.type }}</td>
          <td>{{ log.input }}</td>
          <td>
            <q-badge :color="log.result === 'SUCCESS' ? 'positive' : 'negative'">
              {{ log.result }}
            </q-badge>
          </td>
          <td>{{ log.detail }}</td>
        </tr>
        <tr v-if="!logs.length">
          <td colspan="5" class="text-center text-grey-7">아직 기록이 없습니다.</td>
        </tr>
      </tbody>
    </q-markup-table>
  </div>
</template>

<style scoped lang="scss">
.section-title {
  font-size: 1rem;
  font-weight: 700;
}
</style>
